import { getTotalPrice } from '@shared/lib/money';
import { RowSeatFragment } from '@websky/graphql';

import { Money as MoneyType } from '../../../../Money/types';

export function getSeatPrice(seat: RowSeatFragment): MoneyType {
	if (seat.seatServices?.length) {
		const canAddedServices = seat.seatServices.filter(service => service!.canBeAdded);

		if (canAddedServices.length) {
			return getTotalPrice(canAddedServices, service => service.price!);
		}
	}

	return seat.price!;
}
